<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1100px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col style="width:60px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询条件：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="tableList.tableQuery.search.name"
              placeholder="请输入付款方名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="5">
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          is-index-field
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          @reloadData="loadTableData(tableList)"
          @add="addFun"
          @edit="editFun(arguments)"
          @remove="removeFun(arguments)"
          @view="viewFun(arguments)"
          @dblclick="viewFun(arguments)"
        />
      </div>

      <!-- 新增 修改 查看 -->
      <add-edit-view-dialog
        :event-type="eventType"
        :data-id="id"
        :dialog-title="dialogAddEditViewTitle"
        :dialog-visible.sync="dialogAddEditViewVisible"
        :master-table-key="tableList.tableKey"
        @reloadData="reloadMasterData()"
      />
    </div>
  </el-dialog>
</template>
<script>
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin from '@/mixin/dialogTableCustomMixin'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 新增 修改
import addEditViewDialog from './addEditViewDialog'
import { loadPayerListDataApi, saveOrUpdatePayerApi } from '@/api/payerSetting'

export default {
  name: 'PayerSettingList',
  components: { CustomTable, addEditViewDialog },
  mixins: [dialogDragMixin, dialogTableCustomMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      customerName: '',
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'payer_setting_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['payer_setting_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['payer_setting_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['payer_setting_delete'],
            prop: 'remove',
            label: '作废',
            method: 'remove'
          },
          {
            permissionSigns: ['payer_setting_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          sort: { // 排序对象
            prop: '', // 排序字段
            order: '' // 排序类型 ascending升序 descending降序
          },
          search: {
            name: ''
          }
        }
      },
      isPaging: true,
      id: null,
      eventType: '',
      dialogAddEditViewTitle: '',
      dialogAddEditViewVisible: false
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.multipleSelection = []
        this.tableList.initTableColumn = [
          { prop: 'rowNumber', label: '序号', width: 80 },
          { prop: 'provinceName', label: '省区', filterColumn: 'province_name', width: 90 },
          { prop: 'cityName', label: '城市', filterColumn: 'city_name', width: 100 },
          { prop: 'name', label: '付款方名称', filterColumn: 'name', width: 160 },
          { prop: 'bankName', label: '付款银行名称', filterColumn: 'bank_name', width: 240 },
          { prop: 'bankNo', label: '付款银行账号', filterColumn: 'bank_no' },
          { prop: 'operatorName', filterColumn: 'operator_name', label: '操作人', width: 90 },
          { prop: 'operationTimeValue', filterColumn: 'operation_time', label: '操作时间', width: 150, isBetween: true }
        ]
        this.tableList.tableColumns = this.tableList.initTableColumn
        this.tableList.tableQuery.sort = { prop: '', order: '' }
        this.searchData(this.tableList)
      }
    }
  },
  methods: {
    // 请求数据
    requestData () {
      this.tableList.tableLoading = true
      loadPayerListDataApi({ condition: JSON.stringify(this.tableList.tableQuery) }).then(response => {
        this.tableList.tableLoading = false
        let data = response.data.data || []
        this.handleData(this.tableList, data)
        this.tableList.tableDataTotal = response.data.recordsTotal || 0
      }).catch()
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
    // 刷新列表
    reloadMasterData () {
      this.loadTableData(this.tableList)
    },
    // 新增
    addFun () {
      this.eventType = 'add'
      this.dialogAddEditViewTitle = '新增付款方'
      this.dialogAddEditViewVisible = !this.dialogAddEditViewVisible
    },
    // 修改
    editFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要修改的付款方', type: 'warning' })
        return
      }
      this.id = args[0].id
      this.eventType = 'edit'
      this.dialogAddEditViewTitle = '修改付款方'
      this.dialogAddEditViewVisible = !this.dialogAddEditViewVisible
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要查看的付款方', type: 'warning' })
        return
      }
      this.id = args[0].id
      this.eventType = 'view'
      this.dialogAddEditViewTitle = '查看付款方'
      this.dialogAddEditViewVisible = !this.dialogAddEditViewVisible
    },
    // 作废
    removeFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要作废的付款方', type: 'warning' })
        return
      }

      this.$confirm(
        '是否确定作废该付款方？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
      ).then(async () => {
        saveOrUpdatePayerApi({ id: args[0].id, isDelete: "true" }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
            this.loadTableData(this.tableList)
          }
        })
      }).catch(() => { })
    }
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
